<template>
  <div id="mecanizado-registra">
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-layout align-center justify-center>
      <v-flex lg10>
        <v-card>
          <v-container>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Empadronamiento Alumno</v-toolbar-title
              >
            </v-toolbar>
            <v-form>
              <v-container>
                <v-layout>
                  <v-flex>
                    <data-mecanizado-history
                      :id="id"
                      :tipeView="tipeView"
                    ></data-mecanizado-history>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Vue from "vue";
import DataMecanizadoHistory from "@/modules/configuration/mecanizadoHistory/views/MecanizadoHistoryData.vue";
import { misMixins } from "@/mixins/myMixing.js";
import axios from "axios";

export default {
  name: "mecanizado-registra",
  components: {
    DataMecanizadoHistory,
  },
  props: {},

  data: () => ({
    documentoId: "",
    id: "",
    tipeView: "",
  }),

  computed: {},
  mounted() {},
  created() {
    this.tipeView = this.$route.params.tipeView;
  },

  methods: {
    volver() {
      this.$router.back();
    },
  },
};
</script>
